import {
  moneyIcon,
  protectionIcon,
  personIcon,
  likeIcon,
  fitness1,
  fitness2,
  fitness3,
  fitness4,
  fitness5,
  fitness6,
  fitness7,
  estate1,
  estate2,
  estate3,
  estate4,
  estate5,
  estate6,
  estate7,
  pricingCheckIcon,
  dashedIcon,
  p1,
  p2,
  p3,
  p4,
  p5,
  p6,
} from '../assets/index'
import styles from './utils.module.css'

const AccordionData = [
  {
    id: 0,
    title: 'What is CirclePlug?',
    intro:
      "Imagine a civilised place where you can find your niche. Whether you want to spend time with a close circle of friends or meet new like-minded people, this space offers an opportunity to connect with others effortlessly and hang out more often. CirclePlug believes in keeping it simple, modern, and fun by displaying only what matters most to you—the conversations you actively engage in based on your participation. See our full feature set, and you'll discover amazing features you and your community will love.",
  },
  {
    id: 1,
    title: 'How can I create an account on CirclePlug app?',
    answer: [
      'Download the CirclePlug app from the App Store or Google Play Store.',
      'Open the app and click on the "Sign up" or "Create an account" button.',
      'Enter your name, email address, and a strong password.',
      'Click on the "Sign up" button.',
      'You will receive a confirmation OTP Code in the email address you provided. Follow the instructions in the email to verify your account.',
      'Once your account is verified, you can log in to the CirclePlug app and start exploring communities or create your own community.',
    ],
  },
  {
    id: 2,
    title: 'How can I join a community on CirclePlug app?',
    answer: [
      'Open the CirclePlug app and log in to your account.',
      'Click on the "Communities" tab in your personal CirclePlug account page, then click the Find Community button below.',
      'Browse through the list of available communities or search for a specific community using the search bar.',
      'Once you find a community you are interested in, click on it to view its details.',
      'If the community is open and accepting new members, you can click on the "Join" button to request to join the community.',
      'Some communities may require approval from the community owner or moderator before you can join. In that case, you will need to wait for approval.',
      'Once you are approved to join the community, you can start participating in discussions and accessing any courses, memberships, or offers that the community provides.',
    ],
  },
  {
    id: 3,
    title: 'Can I create my own community on CirclePlug app?',
    answer: [
      'Open the CirclePlug app and log in to your account.',
      'Click on the "Communities" tab in your personal CirclePlug account page, then click on the plus button in the community page.',
      'Click on the "Request to create a community" button.',
      'Tell us about the community you plan to create, what products you are interested in, and choose a category that best fits your community.',
      'Your community request will be reviewed and approved within 24 hours.',
      'Once your community is approved, set it up and invite your members to join and collaborate within your community',
    ],
  },
  {
    id: 4,
    title: 'What kind of features are available on CirclePlug?',
    intro:
      'The CirclePlug app offers a range of features for brands and customer engagement. Here are some of the key features:',
    answer: [
      'Branded community portfolio: Your community page is customized for your brand, including adding a logo, a description, and community rules.',
      "Discussion Thread: The CirclePlug app offers a discussion thread for your brand's community, allowing customers to connect with each other and ask questions.",
      "Events: You can create and promote events for your brand's community, either online or in person.",
      // 'Fund-raising : You can reach your financial goals within your community by creating fund-me campaign and getting donations from your community members.',
      "Private messaging: The CirclePlug app allows customers to privately message each other and interact with your brand's support team.",
      "Analytics: The CirclePlug app provides analytics on your community's performance, including engagement metrics and member demographics.",
      'Reach-out Box: Engage directly with your audience using a personalized reach-out box',
    ],
    otherInfo:
      "Overall, the CirclePlug app provides a range of features for brands to engage with customers and build a community around their products or services. Whether you're looking to provide support, foster customer loyalty, or generate buzz for new products, the CirclePlug app has the tools you need to succeed.",
  },
  {
    id: 5,
    title: 'What kind of features are available on CirclePlug?',
    intro:
      'CirclePlug app offers a variety of features for social groups and NGOs to build and engage with their community. Some of the key features include:',
    answer: [
      'Events: Social groups and NGOs can create and manage events within their community',
      'Donations: CirclePlug app includes donation functionality, allowing social groups and NGOs to receive donations directly within the app.',
      'Volunteer management: Social groups and NGOs can use the platform to manage volunteers.',
      'Document sharing: Groups can upload and share documents such as newsletters, flyers, or other important information.',
      'Discussions: CirclePlug app provides a variety of discussion tools, such as forums, chat rooms, and comment threads, to facilitate community engagement and collaboration.',
      'Payments and membership subscription: Create custom subscription plans, get your community members to subscribe to your plan, and receive payment directly into your community wallet.',
    ],

    otherInfo:
      'CirclePlug app provides a comprehensive set of features that can help social groups and NGOs build, manage, and engage with their community.',
  },
]

const estateManageentSteps = [
  {
    id: 1,
    step: 'Sign Up',
    desc: 'Create your account and get started.',
  },
  {
    id: 2,
    step: 'Create Community',
    desc: 'Establish your estate community on CirclePlug.',
  },
  {
    id: 3,
    step: 'Access Benefits',
    desc: 'Unlock all the tools to manage your estate activities effectively.',
  },
  {
    id: 4,
    step: 'Engage',
    desc: 'Connect, collaborate, and manage your estate seamlessly with CirclePlug.',
  },
]

const benefitsOfCommunity = [
  {
    id: 1,
    icon: moneyIcon,
    title: 'Streamlined Earnings',
    desc: 'Monetize your fitness community swiftly with our efficient financial transactions. Leverage our auto-renewal feature to effortlessly handle recurring payments',
  },
  {
    id: 2,
    icon: protectionIcon,
    title: 'Reliable Fitness  Management',
    desc: 'CirclePlug simplifies fitness center operations by providing a comprehensive platform for managing and welcoming all members, empowering your business.',
  },
  {
    id: 3,
    icon: personIcon,
    title: 'Better Interaction',
    desc: 'Foster a sense of community and interaction within your fitness channel. Use all features to introduce deals, promotions, and referral initiatives, driving up your fitness  revenue',
  },
  {
    id: 4,
    icon: likeIcon,
    title: 'Member Identification',
    desc: 'Digital resident IDs and gate pass access codes heighten security, allowing only authorized members entry to your estate while digitally logging all access activity.',
  },
]

const carouselItems = [
  {
    id: 1,
    title: 'Access Control',
    image: fitness1,
    description: `
      CirclePlug helps you manage member access, track sessions, and see all activity details. You can also check subscriptions and enhance the overall management of your fitness center. It makes it easier to run your fitness community effectively.
    `,
  },
  {
    id: 2,
    title: 'Event Management',
    image: fitness2,
    description: `
       CirclePlug enables event creation and ticket sales on its platform, offering event management tools for effective organization, attendee automation, payment processing, and more.`,
  },
  {
    id: 3,
    title: 'Gym Membership',
    image: fitness3,
    description: `
      CirclePlug simplifies gym membership payments with customizable plans, automating renewals and ensuring consistent revenue collected seamlessly from the community wallet.
    `,
  },
  {
    id: 4,
    title: 'Registration fees',
    image: fitness4,
    description: `
      CirclePlug enables seamless one-time registration payments for new fitness center members, ensuring funds are received in your CirclePlug wallet and access is restricted until payment is made.
    `,
  },
  {
    id: 5,
    title: 'Channels',
    image: fitness5,
    description: `
     CirclePlug enhances communication with group channels and direct messaging, fostering interaction without sharing personal info and encouraging engagement with a thread timeline.
    `,
  },
  {
    id: 6,
    title: 'Session Check In',
    image: fitness6,
    description: `
    CirclePlug manages session check-ins to track attendance accurately. Members can easily check into classes using the app, ensuring their attendance is recorded. Streamline the check-in process and maintain precise attendance records.
    `,
  },
  {
    id: 7,
    title: 'Member Identity',
    image: fitness7,
    description: `
     CirclePlug provides each member with a digital ID card in the app. This ID includes a photo and unique identification number, enhancing security and personalization. Members can easily display their ID for access control and identification.
    `,
  },
]

const estatebenefitsOfCommunity = [
  {
    id: 1,
    icon: moneyIcon,
    title: 'Efficient Estate Administration',
    desc: 'Digital resident IDs and gate pass access codes heighten security, allowing only authorized members entry to your estate while digitally logging all.',
  },
  {
    id: 2,
    icon: protectionIcon,
    title: 'Property Fees',
    desc: 'Easily collect estate dues and automate recurring payments with our auto-renewal feature, maximizing revenue potential and simplifying fund transfers.',
  },
  {
    id: 3,
    icon: personIcon,
    title: 'Better Interaction',
    desc: "With CirclePlug's  platform, you can enhance communication within your estate, promoting engagement  among residents. ",
  },
  {
    id: 4,
    icon: likeIcon,
    title: 'Member Identification',
    desc: 'Digital resident IDs and gate pass access codes heighten security, allowing only authorized members entry to your estate while digitally logging all access activity.',
  },
]

const productbenefitsOfCommunity = [
  {
    id: 1,
    icon: moneyIcon,
    title: 'Smooth Operations',
    desc: 'Centralized management of products, inventory, and orders reduces operational complexity and enhances efficiency.',
  },
  {
    id: 2,
    icon: protectionIcon,
    title: 'Increased Sales and Revenue',
    desc: 'Customizable promotions, service packages, and discount codes help attract and retain customers, boosting sales.',
  },
  {
    id: 3,
    icon: personIcon,
    title: 'Enhanced Customer Experience',
    desc: 'Efficient order processing, accurate inventory tracking, and detailed receipts improve customer satisfaction and loyalty.',
  },
  {
    id: 4,
    icon: likeIcon,
    title: 'Comprehensive Reporting',
    desc: 'Detailed sales, inventory, and financial reports provide valuable insights for informed decision-making.',
  },
]

const estateCarouselItems = [
  {
    id: 1,
    title: 'Estate dues',
    image: estate1,
    description: `
      CirclePlug simplifies estate due collection by allowing owners to set payment amounts and frequencies. It automates renewals and ensures consistent revenue through seamless payments from a community wallet.
    `,
  },
  {
    id: 2,
    title: 'Member directory',
    image: estate2,
    description: `
      CirclePlug enables onboarding all estate residents into a central directory, collecting basic information like name, phone number, and address. It also allows specifying estate executives and their designations.
    `,
  },
  {
    id: 3,
    title: 'Walk in Guest',
    image: estate3,
    description: `
      CirclePlug allows you to digitally record check-in and check-out information for all walk-in guests, eliminating the need for book records and making this data easily accessible and analyzable.
    `,
  },
  {
    id: 4,
    title: 'Channels',
    image: estate4,
    description: `
      CirclePlug enables estate collaboration by providing an information page for sharing vital updates and creating group channels for various resident conversations.
    `,
  },
  {
    id: 5,
    title: 'Resident ID',
    image: estate5,
    description: `
     CirclePlug creates digital ID cards for residents with passport photos on the app for easy display and scanning by estate security, enhancing security and identification.
    `,
  },
  {
    id: 6,
    title: 'Enforce everything',
    image: estate6,
    description: `
    With advanced settings, CirclePlug lets you enforce compliance and revenue goals in your estate. For example, only paid members can generate Gate Pass access codes or access their identity cards.
    `,
  },
  {
    id: 7,
    title: 'Access Control',
    image: estate7,
    description: `
     CirclePlug lets residents generate gate pass access codes for visitors, validated by security for entry, streamlining access without constant gate calls and providing a full visit record for traffic tracking.
    `,
  },
]
const productCarouselItems = [
  {
    id: 1,
    title: 'Overview',
    image: p1,
    description: `
     Stay on top of your business performance by monitoring key metrics such as outstanding payments, revenue, pending requests, and popular products or services. Identify areas for improvement and seize revenue opportunities.
    `,
  },
  {
    id: 2,
    title: 'Orders',
    image: p2,
    description: `
      Efficiently manage all your business orders with comprehensive tracking and categorization. Monitor order statuses, process payments, and keep track of customer details with ease.
    `,
  },
  {
    id: 3,
    title: 'Back Store',
    image: p3,
    description: `
      Efficiently manage offline payments and customer orders for your business. Keep track of cart items, process transactions, and ensure smooth operations with our back store management features.
    `,
  },
  {
    id: 4,
    title: 'Payment Receipt',
    image: p4,
    description: `
      Easily manage and view all payment transactions for your business. Track successful, failed, and pending payments with detailed receipts and order information. Ensure smooth transaction management with CirclePlug.
    `,
  },
  {
    id: 5,
    title: 'Order Creation',
    image: p5,
    description: `
     Easily manage and expand your business offerings with our  tools. Add new products, categorize services, create orders, and generate custom invoices to keep your operations running smoothly.

    `,
  },
  {
    id: 6,
    title: 'Store Settings',
    image: p6,
    description: `
    Customize and manage your store settings and invoicing options for a seamless shopping experience. Control everything from store hours and checkout methods to delivery options and invoice details.
    `,
  },
]

const titleColumn = [
  {
    id: 1,
    title: 'Members',
  },
  {
    id: 2,
    title: 'Members Identity Cards',
  },
  {
    id: 3,
    title: 'Free Community Admin Member',
  },

  {
    id: 4,
    title: 'Paid Community Admin Member',
  },
  {
    id: 5,
    title: 'Subscribe members to community plans',
  },
  {
    id: 6,
    title: 'Collect onetime registration fee from your members',
  },
  {
    id: 7,
    title: 'Community Member profile lock',
  },
  {
    id: 8,
    title: 'Sync community profile to global profile',
  },
  {
    id: 9,
    title: 'Members Identity Photo Lock',
  },
  {
    id: 10,
    title: 'Channels',
  },
  {
    id: 11,
    title: 'Channel history',
  },
  {
    id: 12,
    title: 'Direct messaging',
  },
  {
    id: 13,
    title: 'Admin Reach-out box',
  },
  {
    id: 14,
    title: 'Support Ticket',
  },
  {
    id: 15,
    title: 'Events',
  },
  {
    id: 16,
    title: 'Free Public Event',
  },
  {
    id: 17,
    title: 'Gifting',
  },
  {
    id: 18,
    title: 'Crowd Control',
  },
  {
    id: 19,
    title: 'Reporting downloading',
  },
  {
    id: 20,
    title: 'Processing Fee',
  },
  {
    id: 21,
    title: 'In-app otifications',
  },
  {
    id: 22,
    title: 'Advance reporting & analytics',
  },
  {
    id: 23,
    title: 'Email Business ervice support',
  },
  {
    id: 24,
    title: 'In app Business chat support',
  },
  {
    id: 25,
    title: 'Priority Business service support',
  },
  {
    id: 26,
    title: 'Pay for what you see',
  },
  {
    id: 27,
    title: 'Admin Member Access',
  },
  {
    id: 28,
    title: 'Support Ticket',
  },
  {
    id: 29,
    title: 'Members Identity Card',
  },
  {
    id: 30,
    title: 'Members Identity Card Photo Change',
  },
  {
    id: 31,
    title: 'Public Event',
  },
]

const column1 = [
  {
    id: 1,
    desc: 'Unlimited',
  },
  {
    id: 2,
    desc: '50 Free Identity Cards',
  },
  {
    id: 3,
    desc: pricingCheckIcon,
  },
  {
    id: 4,
    desc: '1 Free',
  },
  {
    id: 5,
    desc: pricingCheckIcon,
  },
  {
    id: 6,
    desc: pricingCheckIcon,
  },
  {
    id: 7,
    desc: dashedIcon,
  },
  {
    id: 8,
    desc: dashedIcon,
  },
  {
    id: 9,
    desc: dashedIcon,
  },

  {
    id: 10,
    desc: pricingCheckIcon,
  },
  {
    id: 11,
    desc: '90-day history access',
  },
  {
    id: 12,
    desc: pricingCheckIcon,
  },
  {
    id: 13,
    desc: pricingCheckIcon,
  },
  {
    id: 14,
    desc: '10 Free ticket per month',
  },

  {
    id: 15,
    desc: pricingCheckIcon,
  },
  {
    id: 16,
    desc: 'No',
  },
  {
    id: 17,
    desc: pricingCheckIcon,
  },
  {
    id: 18,
    desc: dashedIcon,
  },
  {
    id: 19,
    desc: dashedIcon,
  },

  {
    id: 20,
    desc: '10% per month',
  },
  {
    id: 21,
    desc: pricingCheckIcon,
  },
  {
    id: 22,
    desc: pricingCheckIcon,
  },
  {
    id: 23,
    desc: pricingCheckIcon,
  },
  {
    id: 24,
    desc: dashedIcon,
  },
  {
    id: 25,
    desc: dashedIcon,
  },

  {
    id: 26,
    desc: '',
  },
  {
    id: 27,
    desc: '',
  },
  {
    id: 28,
    desc: '',
  },
  {
    id: 29,
    desc: '',
  },
  {
    id: 30,
    desc: '',
  },
  {
    id: 31,
    desc: '',
  },
]

const column2 = [
  {
    id: 1,
    desc: 'Unlimited',
  },
  {
    id: 2,
    desc: '500 Free Identity Cards',
  },
  {
    id: 3,
    desc: pricingCheckIcon,
  },
  {
    id: 4,
    desc: '5 Free',
  },
  {
    id: 5,
    desc: pricingCheckIcon,
  },
  {
    id: 6,
    desc: pricingCheckIcon,
  },
  {
    id: 7,
    desc: pricingCheckIcon,
  },
  {
    id: 8,
    desc: dashedIcon,
  },
  {
    id: 9,
    desc: dashedIcon,
  },

  {
    id: 10,
    desc: pricingCheckIcon,
  },
  {
    id: 11,
    desc: 'Unlimited',
  },
  {
    id: 12,
    desc: pricingCheckIcon,
  },
  {
    id: 13,
    desc: pricingCheckIcon,
  },
  {
    id: 14,
    desc: '100 Free ticket per month',
  },

  {
    id: 15,
    desc: pricingCheckIcon,
  },
  {
    id: 16,
    desc: '5 Free per month',
  },
  {
    id: 17,
    desc: pricingCheckIcon,
  },
  {
    id: 18,
    desc: pricingCheckIcon,
  },
  {
    id: 19,
    desc: pricingCheckIcon,
  },

  {
    id: 20,
    desc: '8% per month',
  },
  {
    id: 21,
    desc: pricingCheckIcon,
  },
  {
    id: 22,
    desc: pricingCheckIcon,
  },
  {
    id: 23,
    desc: pricingCheckIcon,
  },
  {
    id: 24,
    desc: pricingCheckIcon,
  },
  {
    id: 25,
    desc: dashedIcon,
  },

  {
    id: 26,
    desc: '',
  },
  {
    id: 27,
    desc: '$5 per month',
  },
  {
    id: 28,
    desc: '$0.19 per support ticket',
  },
  {
    id: 29,
    desc: '$0.99 per identity card',
  },
  {
    id: 30,
    desc: '$0.49 per identity card',
  },
  {
    id: 31,
    desc: '$1.99 per public event',
  },
]

const column3 = [
  {
    id: 1,
    desc: 'Unlimited',
  },
  {
    id: 2,
    desc: 'Unlimited',
  },
  {
    id: 3,
    desc: pricingCheckIcon,
  },
  {
    id: 4,
    desc: '15 Free',
  },
  {
    id: 5,
    desc: pricingCheckIcon,
  },
  {
    id: 6,
    desc: pricingCheckIcon,
  },

  {
    id: 7,
    desc: pricingCheckIcon,
  },

  {
    id: 8,
    desc: pricingCheckIcon,
  },

  {
    id: 9,
    desc: pricingCheckIcon,
  },

  {
    id: 10,
    desc: pricingCheckIcon,
  },
  {
    id: 11,
    desc: 'Unlimited',
  },
  {
    id: 12,
    desc: pricingCheckIcon,
  },
  {
    id: 13,
    desc: pricingCheckIcon,
  },
  {
    id: 14,
    desc: 'Unlimited',
  },

  {
    id: 15,
    desc: pricingCheckIcon,
  },
  {
    id: 16,
    desc: 'Unlimited',
  },
  {
    id: 17,
    desc: pricingCheckIcon,
  },
  {
    id: 18,
    desc: pricingCheckIcon,
  },
  {
    id: 19,
    desc: pricingCheckIcon,
  },

  {
    id: 20,
    desc: '5% per month',
  },

  {
    id: 21,
    desc: pricingCheckIcon,
  },
  {
    id: 22,
    desc: pricingCheckIcon,
  },

  {
    id: 23,
    desc: pricingCheckIcon,
  },
  {
    id: 24,
    desc: pricingCheckIcon,
  },
  {
    id: 25,
    desc: pricingCheckIcon,
  },

  {
    id: 26,
    desc: '',
  },
  {
    id: 27,
    desc: '',
  },
  {
    id: 28,
    desc: '',
  },
  {
    id: 29,
    desc: '',
  },
  {
    id: 30,
    desc: '',
  },
  {
    id: 31,
    desc: '',
  },
]

const termsofservicetitles = [
  {
    id: 1,
    title: 'Who may use the Services?',
  },
  {
    id: 2,
    title: 'What you can share?',
  },
  {
    id: 3,
    title: 'Content on CirclePlug',
  },
  {
    id: 4,
    title: 'Using the Services',
  },
  {
    id: 5,
    title: 'Limitations of Liability',
  },

  {
    id: 6,
    title: 'Updating our Terms',
  },
  {
    id: 7,
    title: 'Account suspension or termination',
  },
  {
    id: 8,
    title: 'Privacy',
  },
  {
    id: 9,
    title: 'CirclePlug Services and Role',
  },
  {
    id: 10,
    title: 'Release',
  },
  {
    id: 11,
    title: 'Indemnification',
  },
  {
    id: 12,
    title: 'Fees and Refunds',
  },
  {
    id: 13,
    title: 'Acceptable Use',
  },
  {
    id: 14,
    title: 'No Warranties',
  },
  {
    id: 15,
    title: 'Exceptions',
  },
  {
    id: 16,
    title: 'Other parties',
  },
  {
    id: 17,
    title: 'Unenforceable Provisions',
  },
  {
    id: 18,
    title: 'Indemnity',
  },
  {
    id: 19,
    title: 'Breaches Of These Terms And Conditions',
  },
  {
    id: 20,
    title: 'Assignment',
  },
  {
    id: 24,
    title: 'Sever-ability',
  },
  {
    id: 21,
    title: 'Dispute Resolution',
  },
  {
    id: 22,
    title: 'Entire Agreement',
  },
  {
    id: 23,
    title: 'Registrations And Authorizations',
  },
  {
    id: 24,
    title: 'Disclaimer',
  },
  {
    id: 25,
    title: 'Governing Law',
  },
  {
    id: 26,
    title: 'Conversion To Other Languages',
  },
  {
    id: 27,
    title: 'Payment Methods',
  },
  {
    id: 28,
    title: 'Fees and Taxes',
  },
  {
    id: 29,
    title: 'Termination',
  },
  {
    id: 30,
    title: 'To Report Copyright Infringement',
  },
]

const helplist = [
  {
    id: 1,
    title: 'Creating account on CirclePlug ',
    description: `Download the CirclePlug app from your favourite app store
Note: You must be at least 13 years old to create a CirclePlug account.
Get started with Enter your email address or mobile phone number, we validate either your email or phone number before you can proceed.
Once your email or phone number is validated, proceed to providing your Name and Password.
When you create a new password, remember:
Your password should be easy for you to remember but difficult for others to guess.
Your CirclePlug password should be different to the passwords you use to log in to other accounts, such as your email or bank account.
Longer passwords are usually more secure.
Your password should not be your email address, phone number or date of birth. Avoid using common words, such as "password".
Use a password manager. There are many different applications that can store your passwords securely.
Don't share your passwords with anyone, online or in person. If you do, change them as soon as possible.`,
  },
  {
    id: 2,
    title: 'Your Account Settings',
    description: `Log in using your CirclePlug login information
Open the CirclePlug app
Click Email or phone number and enter one of the following:
Email: You can log in with any email address that's listed on your CirclePlug account.
Phone number: If you have a mobile number confirmed on your account, you can enter it here (don't add any zeros before the country code, or any symbols).
Enter your password and click Log in.
Your global account on CirclePlug is connected to all the communities you join.
Your can choose to maintain a different Identity in any community you belong,`,
  },
  {
    id: 3,
    title: 'Deleting your CirclePlug account',
    description:
      'Go to your global profile account on CirclePlug, click on delete account, and follow the process highlighted. Your data will be deleted from CirclePlug. \n If you you delete your CirclePlug account, you also delete all profiles under your communities.',
  },
]

const alltermsofservice = [
  {
    id: 1,
    title: 'Who may use the Services?',
    description: `You may only use the Services if you agree to these Terms and are not prohibited from doing so by the laws of the relevant jurisdiction.You may not use CirclePlug If;you are under the age of 13, you are not permitted to use CirclePlug.we have previously disabled your account as a result of past infractions of our Terms, the Community Standards, or other rules and regulations governing how you use CirclePlug. If we disable your account due to a violation of our Terms, the Community Standards, or any other terms and conditions, you agree not to open another account without our permission. Permission to open a new account is granted at our sole discretion and in no way implies that the disciplinary action taken against you was improper or unjustified.`,
  },
  {
    id: 2,
    title: 'What you can share?',
    description: `Though not at the expense of other people's safety, well-being, or the integrity of our community, we want people to use CirclePlug products to express themselves and share content that is significant to them and their community. As a result, you consent to refrain from engaging in the following behaviours (or helping or encouraging others to do so):
      You may not use our products to do or share anything:
      That violates this agreement, community standards, and other terms and policies that govern how you use our products.
      That is improper, deceptive, discriminating, or fraudulent (or encourages another person to use our products improperly).
      That you do not possess or possess only under licence.
      That, unless an exception or restriction is permitted by current law, infringes or violates another party's rights, including their intellectual property rights (by, for example, violating a copyright or trademark or by disseminating or selling items that are pirated or counterfeit).
      You are not permitted to distribute viruses or other harmful software, transmit spam using our Services, or take any other actions that could obstruct our Services, systems, or products from performing as intended or compromise their integrity.
      Without first getting our approval, you are not allowed to use automated methods to access, gather, or attempt to acquire data from our products that you are not authorised to access.
      You are not permitted to misappropriate access tokens, proxy, request, or collect account information or passwords.
      Except as stated in the Platform Terms, you are not permitted to sell, licence, or buy any data that you have gotten from us or our Services.
      Any reporting, flagging, dispute, or appeals channel may not be abused, including through the filing of false, redundant, or baseless complaints or appeals.
      When any content violates our rules, we have the right to remove it or restrict access to it. Your account may also be suspended or disabled if you act in a way that violates these rules.
      If this option is available in your country, we invite you to report any content or behaviour you believe infringes your rights (including intellectual property rights) or our Terms and Policies in order to support our community.
      Additionally, if we believe that doing so is reasonably required to prevent or mitigate the misuse of our Services or negative legal or regulatory effects on Shypes Integrated Service LTD, we may also remove or restrict access to content features, Services, or information.`,
  },
  {
    id: 3,
    title: 'Content on CirclePlug',
    description:
      'Your use of the Services and any content you provide are your responsibility, and this includes adhering to all applicable laws, rules, and regulations. Only share information that you feel at ease sharing with others.At your own risk, you may use or rely on any information posted through the Services or that you get from the Services. We do not support or represent that any content or communications posted through the Services as being accurate, complete, true, or reliable, and we do not agree with any opinions expressed through the Services.You are aware that using the Services could expose you to content that is offensive, dangerous, inaccurate, or otherwise inappropriate. There may also be instances when postings have been mislabelled or in some other way misleading. The creator of each piece of material is solely responsible for it. The content that is posted through the Services may not be under our supervision or control, and we are not liable for it. We have the right to delete any information that violates the User Agreement, such as impersonation, illegal activity, harassment, or infringement of copyright, trademark, or other intellectual property.',
  },
  {
    id: 4,
    title: 'Using the Services',
    description: `Our Services are constantly evolving. As a result, we reserve the right to make periodic changes to the Services. We reserve the right to stop offering you or other users of the Services (permanently or temporarily) or any features therein. Additionally, we have the right to set restrictions on usage and storage at any moment, solely at our discretion. Without incurring any responsibility to you, we may also delete or refuse to distribute any content on the Services, restrict access to or distribution of any content on the Services, suspend or terminate users, and reclaim usernames. You agree that we and our third-party suppliers and partners may place advertising on the Services or in conjunction with the display of material or information from the Services, whether submitted by you or others, in exchange for us providing you access to and use of the Services. Additionally, you agree not to abuse our Services, such as by tampering with them or using them in a different manner than the interface and instructions we give to access them.You agree that, except and only to the extent that relevant law expressly authorizes, you will not attempt to circumvent any technological restrictions in the software that is made available to you as part of the Services or reverse engineer, decompile, or disassemble the software.While using the Services or gaining access to them, you may not:Access, alter, or use any non-public areas of the Services, our computer systems, or the technical delivery networks of our providers.Probe, scan, or test the vulnerability of any system or network, or circumvent any security or authentication procedures.Unless you have been specifically permitted to do so in a separate agreement with us, you may not access the Services, search the Services, or attempt to access the Services by any means (automated or otherwise), other than through our currently available, published interfaces that are provided by us (and only in accordance with the applicable terms and conditions). NOTE: Crawling the Services is permitted if done in accordance with the robots.txt file; however, scraping the Services is not permitted.Use the Services in any way to send changed, misleading, or fraudulent source-identifying information, including forging any TCP/IP packet header or any portion of the header information in any email or posting.Send a virus, overload, flood, spam, mail-bomb the Services, or script the creation of content in a way that interferes with or places an undue burden on the Services. Interfere with or disrupt (or attempt to disrupt) the access of any user, host, or network.In addition, we reserve the right to access, read, maintain, and disclose any information as we deem reasonably necessary to: (i) comply with any applicable law, regulation, legal process, or governmental request; (ii) enforce the Terms, including looking into possible violations hereof; (iii) detect, prevent, or otherwise address fraud, security, or technical issues; (iv) provide user support; or (v) protect the rights, property, or safety of CirclePlug and its users.CirclePlug offers free registration; however, you may encounter additional terms and conditions when using specific Services or features for which CirclePlug is available. Any additional terms that apply to any of these extra Services are accepted by you by using or paying for them, and those additional terms constitute a part of our contract with you. While you use the Services to which any applicable additional terms apply, if any of them conflict with these terms, the applicable additional terms will take precedence.`,
  },
  {
    id: 5,
    title: 'Limitations of Liability',
    description:
      "You acknowledge that use of any Services or content, including access to them, is at your own risk. To the fullest degree permitted by law, we provide our products 'as is,' and we make no promises that they will always be secure, free from bugs, or operate without interruptions, delays, or flaws. We further disclaim any and all implied warranties, including those of merchantability, fitness for a specific purpose, title, and non-infringement, to the fullest extent permissible by law. We make no guarantee or representation regarding: (i) the reliability, security, timeliness, completeness, or accuracy of the Services or any Content; (ii) any damage to your computer system, loss of data, or other harm resulting from your access to or use of the Services or any Content; and (iii) the deletion or failure to store or transmit any Content or other communications maintained by the Services; and we disclaim all responsibility and liability for all of the aforementioned; and (iv) whether the Services will satisfy your needs or be accessible without interruption, securely, or mistake-free. There are no warranties or representations implied by any advice or information, whether oral or written, that is gained through the Services. We have no influence over what individuals or groups of individuals say or do, and we are not liable for their behaviour, whether it takes place online or offline, or for any information they share that is offensive, inappropriate, obscene, illegal, or otherwise objectionable. We make no warranty or representation and disclaim all responsibility and liability for: (i) the completeness, accuracy, availability, timeliness, security, or reliability of the Services or any Content; (ii) any harm to your computer system, loss of data, or other harm that results from your access to or use of the Services or any Content; (iii) the deletion of, or the failure to store or transmit, any Content and other communications maintained by the Services; and (iv) whether the Services will meet your requirements or be available on an uninterrupted, secure, or error-free basis. No advice or information, whether oral or written, obtained through the Services will create any warranty or representation not expressly made herein. We do not control or direct what people and others do or say, and we are not responsible for their actions or conduct (whether online or offline) or any content that they share (including offensive, inappropriate, obscene, unlawful, or other objectionable content). To the fullest extent permitted by applicable law, we are not liable to you for any lost profits, revenues, information, or data, or for consequential, special, indirect, exemplary, punitive, or incidental damages arising out of or connected with these Terms or the CirclePlug Products, even if we have been informed of the possibility of such damages.",
  },
  {
    id: 6,
    title: 'Updating our Terms',
    description:
      "To make our products better for you and our community, we constantly seek to enhance our Services and provide brand-new features. As a result, we might occasionally need to alter these Terms to represent our Services and practices more accurately, to encourage a secure and safe use of our products and Services, and/or to keep up with legal requirements. We'll endeavour to let you know about significant changes, for instance, by sending an email to the address on file for your account or a service notification. You agree to be bound by the updated Terms if you access or use the Services after those updates take effect. You will be informed in writing via e-mail of any proposed changes to these Terms at least two months before their effective date. Such changes can only take effect with your consent, which may be either express or tacit.",
  },

  {
    id: 7,
    title: 'Account suspension or termination',
    description:
      "We want CirclePlug to be a community where people can engage, express themselves, and share ideas in a welcoming and secure environment.We may suspend or permanently disable your access to CirclePlug Products, and we may permanently disable or delete your account if we deem that you have plainly, seriously, or repeatedly violated our Terms or Policies, including, in particular, the Community Standards. If you frequently violate someone else's intellectual property rights or if we are compelled to do so by law, we may also disable or cancel your account.If, after registration, your account is not verified, if it is dormant for an extended length of time, if we discover that someone may have used it without your permission, or if we are unable to verify your ownership of the account, we may disable or delete your account.",
  },
  {
    id: 8,
    title: 'Privacy',
    description:
      'When you use our Services, you provide us with information, which is handled in accordance with our privacy policy. You are aware that by using the Services, you consent to the information being collected, used (as described in the Privacy Policy), and transferred to us and our affiliates for storage, processing, and usage.',
  },
  {
    id: 9,
    title: 'CirclePlug Services and Role',
    description: '',
  },
  {
    id: 10,
    title: 'Release',
    description:
      "You won’t bring us into any disputes between you and a third party.You hereby agree to release us (collectively with our Affiliates and subsidiaries, and each of our and their respective officers, directors, agents, co-branders, licensors, payment processing partners, vendors, other partners, independent contractors, and employees) from all damages (whether direct, indirect, incidental, consequential, or otherwise), losses, liabilities, costs, and expenses of every kind and nature, known and unknown, arising out of a dispute between you and a third party (including other Users) in connection with any of the following:the Services or any event listed on the Services, including your CirclePug Events.your licence (defined below), any failure to obtain or maintain any licence, or any error in obtaining or maintaining any licence;any feedback (defined below) that you give or receive; orYour content or your trademarksIn addition, you waive any applicable law or statute, which says, in substance: 'A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE RELEASING PARTY DOES NOT KNOW OR SUSPECT TO EXIST IN HIS FAVOUR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM MUST HAVE MATERIALLY AFFECTED HIS SETTLEMENT WITH THE RELEASED PARTY.'",
  },
  {
    id: 11,
    title: 'Indemnification',
    description:
      "You agree to have our back if a third party comes after us because of something you did or failed to do.You agree to defend, indemnify, and hold harmless Shypes Integrated Service Ltd. from any and all damage (whether direct, indirect, incidental, consequential, or otherwise), loss, liability, cost, and expense (including reasonable attorneys' and accounting fees) resulting from any claim, demand, suit, proceeding (whether before an arbitrator, court, mediator, or otherwise) or investigation made by any third party (each a 'Claim') relating to or arising out of:your breach of these Terms (including any terms, agreements, or policies incorporated into these Terms);your unauthorised use of the Services;your licensure, any failure to obtain or maintain any licensure, or any error in obtaining or maintaining any licensure;any feedback that you give or receive;your breach of any applicable local, state, provincial, national, or other law, rule, or regulation, or the rights of any third party;our collection and remission of taxes; and if you are an organiser, your events (including where we have provided Services with respect to those events), your content, and your trademarks, provided that in the case of (7), this indemnification will not apply to the extent that the claim arises out of Shypes Integrated Service Ltd.'s gross negligence or willful misconduct.We will provide notice to you of any such claim, but our failure or delay in providing such notice will not limit your indemnification obligations except to the extent you are materially prejudiced by such failure. Also, in certain circumstances, we may choose to handle the claim ourselves, in which case you agree to cooperate with us in any way we request.",
  },
  {
    id: 12,
    title: 'Fees and Refunds',
    description:
      'We charge the following fees:Creating an account and listing an event are free. However, we may charge fees when you pay for the followingpaid event tickets,membership and ;one time registration charged by community owners. These fees may vary based on individual agreements between us and certain community owners. The fees charged to consumers may include other charges, including facility fees, royalties, applicable taxes, processing fees, and fulfilment fees. This means that the fees paid by consumers for  any paid service are not the same as those charged by us to the applicable organizer or the standard fees described on the Services to Organizers page. In addition, some fees are meant to cover costs incurred by us but may in some cases include an element of profit and in some cases include an element of loss. We do not control (and cannot disclose) fees levied by your bank and/or credit card company, including fees for purchasing tickets and registrations in foreign currencies or from foreign persons. Be sure to check with your bank or credit card company prior to purchasing to understand all applicable fees, credit card surcharges, and currency conversion rates.',
  },
  {
    id: 13,
    title: 'Acceptable Use',
    description:
      'You must not use Circleplug in any way that causes, or may cause, and or discredit the image, reputation, standard or impairment of its authenticity; or in any way which is unlawful, illegal, fraudulent, or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity,',
  },
  {
    id: 14,
    title: 'No Warranties',
    description:
      'Circleplug app/website is provided “as is” without any representations or warranties, express or implied. Circleplug make no representations or warranties in relation to our product, or the information and materials provided to us. Without prejudice to the generality of the foregoing paragraph, Circleplug Limited, its partners and affiliates do not warrant that:i. the Services shall at all times be uninterrupted by network, or service providers',
  },
  {
    id: 15,
    title: 'Exceptions',
    description:
      'Nothing in this terms and condition shall exclude or limit any warranty implied by law that it would be unlawful to exclude or limit; and nothing in this terms and conditions shall exclude or limit Circleplug liability in respect of any:Fraud or fraudulent misrepresentation on the part of Circleplug; or Matter, which it would be illegal or unlawful for Circleplug to exclude or limit, or to attempt or purport to exclude or limit its liability.',
  },
  {
    id: 16,
    title: 'Other parties',
    description:
      'You accept that as a limited liability entity, Circleplug has an interest in limiting the personal liability of its officers and employees. You agree that you will not bring any claim personally against its officers, management, or employees in respect of any losses you suffer in connection with the Circleplug Service. Without prejudice to the foregoing paragraph, you agree that the limitations of warranties and liability set out in herein will protect its officers, employees, agents, subsidiaries, successors, assigns and sub-contractors as well as Circleplug.',
  },
  {
    id: 17,
    title: 'Unenforceable Provisions',
    description:
      'If any provision of this terms and condition is or is found to be unenforceable under applicable law that will not affect the enforceability of the other provisions of this website disclaimer.',
  },
  {
    id: 18,
    title: 'Indemnity',
    description:
      'You hereby indemnify Circleplug and undertake to keep Circleplug indemnified against any losses, damages, costs, liabilities and expenses (including without limitation legal expenses and any amounts paid by it to a third party in settlement of a claim or dispute on the advice of its legal advisers) incurred or suffered by Circleplug arising out of any breach by you of any provision of these terms and conditions, [or arising out of any claim that you have breached any provision of these terms and conditions] stated herein or in respect to the Services.',
  },
  {
    id: 19,
    title: 'Breaches Of These Terms And Conditions',
    description:
      'Without prejudice to Circleplug other rights under these terms and conditions, if you breach these terms and conditions in any way, it may take such action as it deems appropriate to deal with the breach, including suspending your access to the Service, prohibiting you from accessing the Service, blocking or disabling your account; and also report you to the relevant security agency or authority and/or bringing court proceedings against you.',
  },
  {
    id: 20,
    title: 'Assignment',
    description:
      'Circleplug may transfer, sub-contract or otherwise deal with its rights and/or obligations under these terms and conditions without notifying you or obtaining your consent.You may not transfer, sub-contract or otherwise deal with your rights and/or obligations under these terms and conditions.',
  },
  {
    id: 21,
    title: 'Sever-ability',
    description:
      'If a provision of these terms and conditions is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect. If any unlawful and/or unenforceable provision would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect.',
  },
  {
    id: 22,
    title: 'Dispute Resolution',
    description:
      'In the event of any dispute arising thereof, or any other agreement or instrument made in furtherance to this terms and agreement, you agree to notify Circleplug and thereafter to settle same by resolution between the parties and where all channels of resolution has failed an Arbitrator shall be appointed by the President of the Chartered Institute of Arbitrators Nigeria ,(UK Branch).The decision of the Arbitrator shall be final as to the contents of this agreement or the instrument and as to the proper mode of carrying the provision into effect.',
  },
  {
    id: 23,
    title: 'Entire Agreement',
    description:
      'These terms and conditions [together with any other documents] constitute the entire agreement between you and CirclePlug in relation to the CirclePlug Service and supersede all previous agreements in respect of your use of CirclePlug.',
  },
  {
    id: 24,
    title: 'Registrations And Authorizations',
    description:
      'CirclePlug is registered with Trademark, Patent and Design Registry.',
  },
  {
    id: 25,
    title: 'Disclaimer',
    description:
      'However, and to the extent permitted by law, neither Circleplug, nor any of its officers, directors, employees, representatives, subsidiaries, affiliated companies, partners, distributors, affiliates, licensees, agents or others involved in creating, sponsoring, promoting, or otherwise making available the Circleplug Service shall be liable for:any punitive, special, indirect or consequential loss or damages, any loss of production, loss of profit, loss of anticipated revenue, loss of or damage to goodwill or reputation, loss of claim etc;i. any punitive, special, indirect, or consequential loss or damages, any loss of production, loss of profit, loss of anticipated revenue, loss of or damage to goodwill or reputation, loss of claim etc.ii. Any inaccuracy relating to the (descriptive) information (including exchange rates, financial policies etc).iii. any (direct, indirect, consequential or punitive) damages, losses or costs suffered, incurred or paid by you, pursuant to, arising out of or in connection with your use of the Services.iv. or any (personal) injury, death, property damage, or other (direct, indirect, special, consequential or punitive) damages, losses or costs suffered, incurred or paid by you, whether due to (legal) acts, errors, breaches, (gross) negligence, wilful misconduct, omissions, non-performance, misrepresentations, tort or strict liability by or (wholly or partly) attributable to any of our other business partners (including any of their employees, directors, officers, agents, representatives or affiliated companies) whose products and Services are (directly or indirectly) made available, offered or promoted on the Circleplug platform, including but not limited to bad network, deduction of any fees, strike, force majeure or any other event beyond the control of Circleplug.',
  },
  {
    id: 26,
    title: 'Governing Law',
    description:
      'Circleplug is governed by the laws and statutes of Nigeria. These Terms & Conditions are valid during your use of the Service until amended or suspended by Circleplug.',
  },
  {
    id: 27,
    title: 'Conversion To Other Languages',
    description:
      'The original English version of these terms and conditions may have been translated into other languages. The translated version is a courtesy and office translation only and you cannot derive any rights from the translated version. In the event of a dispute about the contents or interpretation of these terms and conditions or inconsistency or discrepancy between the English version and any other language version of these terms and conditions, the English language version to the extent permitted by law shall apply, prevail and be conclusive. The English version is available on our website www.circleplug.com.',
  },
  {
    id: 28,
    title: 'Payment Methods',
    description:
      'We use a third-party payment provider to process payments. Use of our payment service shall confirm compliance with the terms and conditions of the third-party payment provider.',
  },
  {
    id: 29,
    title: 'Fees and Taxes',
    description:
      'You are responsible for any fees (internet costs, taxes etc.) incurred by you on account of your use of our Service.',
  },
  {
    id: 30,
    title: 'Termination',
    description:
      'Although we hope you remain a Circleplug user, you can terminate your relationship with Circleplug anytime for any reason by deleting your account. For instructions on how to do so, please see on cancellation/termination of accounts articles in our Help Center.',
  },
  {
    id: 31,
    title: 'To Report Copyright Infringement',
    description:
      'It is Circleplug’s policy to respect the intellectual property rights of others. To report the infringement of copyrighted material, please visit the copyright infringement Page at www.circleplug.com.',
  },
]

const privacypolicytitles = [
  {
    id: 1,
    title: 'Personal information collection',
  },
  {
    id: 2,
    title: 'Use of personal information',
  },
  {
    id: 3,
    title: 'Securing your data',
  },
  {
    id: 4,
    title: 'Cross-border data transfers',
  },
  {
    id: 5,
    title: 'Data Retention',
  },
  {
    id: 6,
    title: 'Your rights',
  },
  {
    id: 7,
    title: 'Other websites',
  },
  {
    id: 8,
    title: "Children's Privacy",
  },
  {
    id: 9,
    title: 'Changes to This Policy',
  },
  {
    id: 10,
    title: 'General',
  },
]

const allprivacypolicies = [
  {
    id: 1,
    title: 'Personal information collection',
    description: `‘Data’ means collectively all information that you submit to CirclePlug Limited via the Website/App. This definition incorporates, where applicable, the definitions provided in the applicable Data Protection Laws.‘Cookies’ means a small text file placed on your computer by this Website when you visit certain parts of the Website/App and/or when you use certain features of the Website/App. Details of the cookies used by this Website are set out in the Cookies Policy‘Data Protection Laws’ means any applicable law relating to the processing of personal Data, including but not limited to the NDPR, and any national implementing and supplementary laws, regulations, and secondary legislation.‘NDPR’ means the Nigeria Data Protection Regulation.‘Circleplug’ / we or us means Circleplug a flagship product of Shypes Integrated Services Limited, a company incorporated in Nigeria with registered number 1199010.‘User or you’ means any third party that accesses the Website and is not either (i) employed by Circleplug Limited and acting in the course of their employment or (ii) engaged as a consultant or otherwise providing services to Circleplug Limited and accessing the Website in connection with the provision of such services; and‘Website/App’ means the website that you are currently using, www.circleplug.com, and any sub-domains of this site unless expressly excluded by their own terms and conditions.`,
  },
  {
    id: 2,
    title: 'Use of personal information',
    description: `CirclePlug may use your personal information to: `,
    items: [
      'Administer this website/app.',
      'Aersonalise the website/app for you.',
      'Send you app-related updates and notifications.',
      'Share your content with other users based on your privacy settings.',
      'Enable your access to and use of the website services',
      'Publish information about you on the website',
      'Send to you products that you purchase.',
      'Supply to your services that you purchase.',
      'Send to your statements and invoices.',
      'Collect payments from you.',
      'Send you marketing communications.',
    ],

    description2: `Where CirclePlug discloses your personal information to its agents or third-party administrators for these purposes, the
     agent or third-party administrator in question will be obligated to use that personal information in accordance with the
     terms of this privacy statement.
     In addition to the disclosures reasonably necessary for the purposes identified elsewhere above, CIRCLEPLUG may
     disclose your personal information to the extent that it is required to do so by law, in connection with any legal
     proceedings or prospective legal proceedings, and to establish, exercise or defend its legal rights.`,
  },
  {
    id: 3,
    title: 'Securing your data',
    description: `CirclePlug will take reasonable technical and organisational precautions to prevent the loss, misuse, or alteration of your personal information.CirclePlug will store all the personal information you provide on its secure servers.All Information relating to electronic transactions entered via this website will be protected by encryption technology.We implement security measures to protect your information from unauthorised access and data breaches. However, no method of data transmission over the internet is completely secure, and we cannot guarantee absolute security.`,
  },
  {
    id: 4,
    title: 'Cross-border data transfers',
    description: `Information that CirclePlug collects may be stored and processed in and transferred between any of the countries in which CirclePlug operates to enable the use of the information in accordance with this privacy policy.In addition, personal information that you submit for publication on the website will be published on the internet and may be available around the world.You agree to such cross-border transfers of personal information.`,
  },
  {
    id: 5,
    title: 'Data Retention',
    description:
      'Unless a longer retention period is required or permitted by law, we will only hold your Data on our systems for the period necessary to fulfil the purposes outlined in this privacy policy or until you request that the Data be deleted. Even if we delete your Data, it may persist on backup or archival media for legal, tax or regulatory purposes.',
  },
  {
    id: 6,
    title: 'Your rights',
    description: `You have the following rights in relation to your Data:a. Right to access - the right to request (i) copies of the information we hold about you at any time, or (ii) that we modify, update, or delete such information. If we provide you with access to the information we hold about you, we will not charge you for this, unless your request is "manifestly unfounded or excessive." Where we are legally permitted to do so, we may refuse your request. If we refuse your request, we will tell you the reasons why.b. Right to correct - the right to have your Data rectified if it is inaccurate or incomplete.c. Right to erase - the right to request that we delete or remove your Data from our systems.d. Right to restrict our use of your Data - the right to "block" us from using your Data or limit the way in which we can use it.e. Right to data portability - the right to request that we move, copy, or transfer your Data.f. Right to object - the right to object to our use of your Data including where we use it for our legitimate interests.To make enquiries, exercise any of your rights set out above, or withdraw your consent to the processing of your Data (where consent is our legal basis for processing your Data), please contact us via this e-mail address: dpo@shypes.com.If you are not satisfied with the way a complaint you make in relation to your Data is handled by us, you may be able to refer your complaint to the relevant data protection authority. For Nigeria, this is the Nigeria Data Protection Regulation (NDPR)).It is important that the Data we hold about you is accurate and current. Please keep us informed if your Data changes during the period for which we hold it.`,
  },
  {
    id: 7,
    title: 'Other websites',
    description: `This website contains links to other websites.
    CirclePlug is not responsible for the privacy policies or practices of any third-party.
Children's Privacy
Our app/website is not intended for users under the age of 13years. We do not knowingly collect personal information from children.`,
  },
  {
    id: 8,
    title: "Children's Privacy",
    description: `Our app/website is not intended for users under the age of 13years. We do not knowingly collect personal information from children.`,
  },
  {
    id: 9,
    title: 'Changes to This Policy',
    description: `We may update this Privacy Policy. We'll notify you of significant changes through app notifications or other means.Our Contact: info@shypes.comIf you have any questions about this privacy policy or wish to report use of your personal information, please write by email to:info@circleplug.com,dpo@shypes.com`,
  },
  {
    id: 10,
    title: 'General',
    description:
      'You may not transfer any of your rights under this privacy policy to any other person. We may transfer our rights under this privacy policy where we reasonably believe your rights will not be affected. If any court or competent authority finds that any provision of this privacy policy (or part of any provision) is invalid, illegal, or unenforceable, that provision or part-provision will, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this privacy policy will not be affected.Unless otherwise agreed, no delay, act, or omission by a party in exercising any right or remedy will be deemed a waiver of that, or any other, right or remedy. This Policy will be governed by and interpreted according to the law of Nigeria. All disputes arising under the Policy will be subject to the exclusive jurisdiction of the Chartered Institute of Arbitration Nigeria (UK Branch).',
  },
]

const spinner = (
  <div className={styles.svg}>
    <svg
      className={styles.svgspin}
      width={30}
      height={20}
      viewBox='0 0 512 512'
    >
      <path
        d='M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z'
        fill='#fff'
      />
    </svg>
  </div>
)

export {
  AccordionData,
  estateManageentSteps,
  benefitsOfCommunity,
  carouselItems,
  estatebenefitsOfCommunity,
  estateCarouselItems,
  titleColumn,
  column1,
  column2,
  column3,
  termsofservicetitles,
  alltermsofservice,
  privacypolicytitles,
  allprivacypolicies,
  helplist,
  spinner,
  productbenefitsOfCommunity,
  productCarouselItems,
}
